export enum TechnicalIssueType {
    ERROR = 'ERROR',
    SUGGESTION = 'SUGGESTION',
    ADD_NCI = 'ADD_NCI',
}

export enum TechnicalIssuePriority {
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
}

export enum TechnicalIssueStatus {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}
